import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Typography, Descriptions } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title } = Typography;

const Profile = () => {
  const { user, updateUserInfo } = useAuth();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  // 处理表单提交
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await updateUserInfo(values);
      message.success('个人信息更新成功');
      setEditing(false);
    } catch (err) {
      message.error('更新失败: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  // 开始编辑
  const startEditing = () => {
    form.setFieldsValue({
      fullname: user?.fullname
    });
    setEditing(true);
  };

  return (
    <div>
      <Title level={2}>个人信息</Title>

      {!editing ? (
        <Card>
          <Descriptions bordered column={1}>
            <Descriptions.Item label="用户名">{user?.username}</Descriptions.Item>
            <Descriptions.Item label="姓名">{user?.fullname}</Descriptions.Item>
            <Descriptions.Item label="用户组">{user?.user_group === 'admin' ? '管理员' : '普通用户'}</Descriptions.Item>
            <Descriptions.Item label="上次登录时间">
              {user?.last_login ? new Date(user.last_login).toLocaleString() : '首次登录'}
            </Descriptions.Item>
            <Descriptions.Item label="大模型使用量">{user?.token_usage || 0} Tokens</Descriptions.Item>
            <Descriptions.Item label="文本解析量">{user?.page_usage || 0} 页</Descriptions.Item>
            <Descriptions.Item label="网课审核时长">
              {user?.video_audit_duration 
                ? `${Math.floor(user.video_audit_duration / 3600)}小时 ${Math.floor((user.video_audit_duration % 3600) / 60)}分钟 ${Math.round(user.video_audit_duration % 60)}秒` 
                : '0秒'}
            </Descriptions.Item>
            <Descriptions.Item label="下载接口使用时长">
              {user?.plaso_api_duration 
                ? `${Math.floor(user.plaso_api_duration / 3600)}小时 ${Math.floor((user.plaso_api_duration % 3600) / 60)}分钟 ${Math.round(user.plaso_api_duration % 60)}秒` 
                : '0秒'}
            </Descriptions.Item>
          </Descriptions>
          <Button 
            type="primary" 
            onClick={startEditing} 
            style={{ marginTop: 16 }}
          >
            修改信息
          </Button>
        </Card>
      ) : (
        <Card>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{
              fullname: user?.fullname
            }}
          >
            <Form.Item
              name="fullname"
              label="姓名"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="姓名" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} style={{ marginRight: 8 }}>
                保存
              </Button>
              <Button onClick={() => setEditing(false)}>
                取消
              </Button>
            </Form.Item>
          </Form>
        </Card>
      )}
    </div>
  );
};

export default Profile; 